<div [formGroup]="userForm" fxLayout="column">
  <div class="mat-error  mb-3" *ngIf="generalError">
    {{generalError?.message}}
  </div>

  <mat-form-field>
    <mat-label>Email </mat-label>
    <input formControlName="email" matInput type="email" name="email">
    <mat-error *ngIf="userForm.controls.email?.errors?.pattern && !userForm.controls.email?.errors?.required">
      Please enter a valid email address
    </mat-error>
    <mat-error *ngIf="userForm.controls.email?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>First name </mat-label>
    <input formControlName="firstName" matInput type="text" name="firstname">
    <mat-error *ngIf="userForm.controls.firstName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Last name </mat-label>
    <input formControlName="lastName" matInput type="text" name="lastname">
    <mat-error *ngIf="userForm.controls.lastName?.errors?.required">
      Field <strong>required</strong>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Phone </mat-label>
    <input formControlName="phone" matInput type="tel" name="phone" [mask]="'+00 000 0*'"
      [dropSpecialCharacters]="false">
    <mat-error *ngIf="userForm.controls.phone?.errors?.pattern && !userForm.controls.phone?.errors?.required">
      Please enter a valid phone number
    </mat-error>
    <mat-error *ngIf="userForm.controls.phone?.errors?.required">
      Field <strong>required</strong>
    </mat-error>

  </mat-form-field>

  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="onCancel()" mat-button>Cancel</button>
    <button (click)="saveUser()" [disabled]="userForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>